<template>
  <div class="summary-amount-menu-items">
    <card-menu-item item-key="info"
                    v-if="showInfoPopups"
                    :onItemClick="emitOpenSectionInfoPopup"
                    :icon-src="require(`@/assets/${infoMenuItemIcon}`)"
                    :text="infoMenuItemText"/>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import BaseUI from 'base-ui';
import SummaryAmountInfoPopup
  from '@/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/info-popups/SummaryAmountInfoPopup';
import InfoPopups
  from '@/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/info-popups/InfoPopups';

export default {
  name: 'SummaryAmountSectionMenu',
  components: {
    CardMenuItem: BaseUI.CardMenuItem,
  },
  mixins: [InfoPopups],
  props: {
    showInfoPopups: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal']),
    emitOpenSectionInfoPopup() {
      this.trackInfoPopupClicked('summaryAmount');
      this.openModal({ component: SummaryAmountInfoPopup });
    },
  },
};
</script>

<style scoped>
.summary-amount-menu-items {
  display: contents;
}
</style>
